import { css } from '@emotion/core';

export const searchResultLinkCSS = css`
    display: flex;
    gap: 0.75rem;
    text-decoration: none;
`;

export const searchResultLinkPlatformCategoryCSS = ({ colors, fontSizes }) =>
    css`
        font-size: ${fontSizes.medium};
        color: ${colors.orange};
    `;

export const searchResultLinkFamilyCategoryCSS = ({ colors, fontSizes }) =>
    css`
        font-size: ${fontSizes.medium};
        color: ${colors.orange};
    `;

export const searchResultLinkCustomerCategoryCSS = ({ colors, fontSizes }) =>
    css`
        font-size: ${fontSizes.medium};
        color: ${colors.blueLight};
    `;
